import { loadManifest, loadRink, loadMarkings, loadPerformance, musicUrlFor, Manifest } from "./data/loadPerformance";
import { Player } from "./ui/player";

const app = document.getElementById("app")!;

function buildPicker(manifest: Manifest, currentId: string): HTMLElement {
  const bar = document.createElement("div");
  bar.className = "picker";
  const label = document.createElement("label");
  label.className = "sel";
  label.textContent = "Performance ";
  const sel = document.createElement("select");
  for (const p of manifest.performances) {
    const o = document.createElement("option");
    o.value = p.id;
    o.textContent = p.title;
    if (p.id === currentId) o.selected = true;
    sel.append(o);
  }
  sel.onchange = () => {
    const u = new URL(location.href);
    u.searchParams.set("performance", sel.value);
    location.href = u.toString();
  };
  label.append(sel);
  bar.append(label);
  return bar;
}

async function boot() {
  try {
    const [manifest, rink, markings] = await Promise.all([loadManifest(), loadRink(), loadMarkings()]);
    const want = new URLSearchParams(location.search).get("performance");
    const entry = manifest.performances.find((p) => p.id === want) ?? manifest.performances[0];
    const perf = await loadPerformance(entry.path);
    const musicUrl = musicUrlFor(entry.path, perf);

    document.title = [perf.meta.team, perf.meta.theme].filter(Boolean).join(" \u2014 ") || perf.meta.id;
    new Player(app, { perf, rink, markings, musicUrl });
    if (manifest.performances.length > 1) app.append(buildPicker(manifest, entry.id));  // picker at the bottom
  } catch (err) {
    app.innerHTML = `<pre class="error">${(err as Error).message}</pre>`;
    throw err;
  }
}
boot();
